import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[QQCARD] uncaught error:', error, info?.componentStack);
  }

  reload = () => {
    try {
      this.setState({ hasError: false, error: null });
    } catch (_) {
      window.location.reload();
    }
  };

  goHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#fafafb',
            color: '#0b0c10',
            padding: 24,
            fontFamily: "'Inter', 'Noto Sans TC', sans-serif",
          }}
        >
          <div
            style={{
              maxWidth: 460,
              textAlign: 'center',
              padding: '40px 32px',
              background: '#ffffff',
              borderRadius: 16,
              border: '1px solid rgba(15, 17, 23, 0.08)',
              boxShadow: '0 8px 24px rgba(15, 17, 23, 0.08)',
            }}
          >
            <div
              style={{
                width: 64,
                height: 64,
                margin: '0 auto 20px',
                borderRadius: 16,
                background: '#fee2e2',
                color: '#dc2626',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 28,
                fontWeight: 800,
              }}
            >
              !
            </div>
            <h2
              style={{
                fontSize: 22,
                margin: '0 0 8px',
                fontFamily: "'Sora', sans-serif",
                fontWeight: 700,
                letterSpacing: '-0.02em',
              }}
            >
              發生了一些問題
            </h2>
            <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.65, margin: '0 0 24px' }}>
              我們已記錄這個錯誤，工程團隊將盡快修復。請點選下方按鈕重試。
            </p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={this.reload}
                style={{
                  padding: '11px 22px',
                  background: '#6d5cff',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 9999,
                  fontWeight: 600,
                  fontSize: 14,
                  cursor: 'pointer',
                }}
              >
                重新整理
              </button>
              <button
                onClick={this.goHome}
                style={{
                  padding: '11px 22px',
                  background: 'transparent',
                  color: '#0b0c10',
                  border: '1px solid rgba(15, 17, 23, 0.1)',
                  borderRadius: 9999,
                  fontWeight: 600,
                  fontSize: 14,
                  cursor: 'pointer',
                }}
              >
                回到首頁
              </button>
            </div>
            {this.state.error?.message && (
              <pre
                style={{
                  marginTop: 24,
                  padding: 12,
                  background: '#f3f4f7',
                  borderRadius: 8,
                  fontSize: 11,
                  textAlign: 'left',
                  overflow: 'auto',
                  color: '#6b7280',
                  fontFamily: 'monospace',
                }}
              >
                {String(this.state.error.message)}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
